import IconGrid, { HORIZONTAL, VERTICAL } from "./IconGrid";
export { HORIZONTAL, VERTICAL };
export default IconGrid;
